import React from "react";
import { Modal } from "react-bootstrap";

const Dialog = ({
  show,
  handleClose,
  title,
  children,
  closeButton,
  ...props
}) => {
  return (
    <Modal show={show} onHide={handleClose} {...props}>
      {title && (
        <Modal.Header closeButton={closeButton}>
          <Modal.Title>{title}</Modal.Title>
        </Modal.Header>
      )}
      <Modal.Body>{children}</Modal.Body>
    </Modal>
  );
};

export default Dialog;
